// 设计稿宽度（根据你的设计稿修改，例如1920px或375px）
const DESIGN_WIDTH = 1920;

// 计算并设置根元素字体大小
function setRemUnit() {
  // 当前屏幕宽度
  const screenWidth = document.documentElement.clientWidth || window.innerWidth;
  
  // 防止屏幕过宽时字体过大（可选限制）
  const maxWidth = 2560;
  const actualWidth = screenWidth > maxWidth ? maxWidth : screenWidth;
  
  // 计算根字体大小：设计稿1920px对应16px，则 1rem = 16px
  // 实际屏幕宽度下，根字体大小 = (实际宽度 / 设计宽度) * 16
  const fontSize = (actualWidth / DESIGN_WIDTH) * 16;
  
  // 设置根元素字体大小（最小12px，最大24px，防止极端情况）
  document.documentElement.style.fontSize = `${Math.min(Math.max(fontSize, 14), 18)}px`;
}

// 初始化执行一次
setRemUnit();

// 监听窗口大小变化
window.addEventListener('resize', setRemUnit);

// 监听屏幕旋转（移动端）
window.addEventListener('orientationchange', setRemUnit);

export default setRemUnit;
    